import { _excel_utils_excel_column_sorted_keys_make, _excel_utils_export_table_with_keyval_header } from "../excel-utils";



/*
*/


export const _zzsurvey_utils_make_date_now_plus_days = (days) => {
  // const current_time_utc = new Date().toISOString();
  const current_timestamp = Date.now();
  const days_timestamp = days * (24 * 3600 * 1000);
  const final_time_utc = new Date(current_timestamp + days_timestamp).toISOString().substring(0, 10);
  /*
  console.log('current_time_utc');
  console.log('current_timestamp');
  console.log('days_timestamp');
  console.log('final_time_utc');
  */
  return final_time_utc;
};


// ----------- form definitions


//
export const _zzsurvey_formDefiinitionLogin = [
  {
    "type": "input_email",
    "params": {
      "label": "email",
      "name": "email",
      // "w": 320
    }
  },
  {
    "type": "input_password",
    "params": {
      "label": "password",
      "name": "password",
      // "w": 320
    }
  },
];


//
export const _zzsurvey_formDefiinitionRegisterSuperadmin = [ // NE KORISTI SE NIGDE
  {
    "type": "input_text",
    "params": {
      "label": "name",
      "name": "name",
      // "w": 320
    }
  },
  /*
  {
    "type": "input_text",
    "params": {
      "label": "surname",
      "name": "surname",
      // "w": 320
    }
  },
  */
  {
    "type": "input_email",
    "params": {
      "label": "email",
      "name": "email",
      // "w": 320
    }
  },
  {
    "type": "input_password",
    "params": {
      "label": "password",
      "name": "password",
      // "w": 320
    }
  },
];


//
export const _zzsurvey_formDefiinitionRegisterSeller = [
  {
    "type": "input_text",
    "params": {
      "label": "name",
      "name": "name",
      // "w": 320
    }
  },
  {
    "type": "input_text",
    "params": {
      "label": "surname",
      "name": "surname",
      // "w": 320
    }
  },
  {
    "type": "input_email",
    "params": {
      "label": "email",
      "name": "email",
      // "w": 320
    }
  },
  {
    "type": "input_password",
    "params": {
      "label": "password",
      "name": "password",
      // "w": 320
    }
  },
];


//
export const _zzsurvey_formDefiinitionClient = [
  {
    "type": "input_text",
    "params": {
      "label": "name",
      "name": "name",
      // "w": 320
    }
  },
  {
    "type": "input_email",
    "params": {
      "label": "email",
      "name": "email",
      // "w": 320
    }
  },
  {
    "type": "input_text",
    "params": {
      "label": "phone",
      "name": "phone",
      // "w": 320
    }
  },
  {
    "type": "logo",
    "params": {
      "label": "* ne popunjavaj (logo)",
      "name": "logo",
      "w": 240
    }
  },
];


//
const OLD_zzsurvey_formDefiinitionCustomer_v1 = (_cb_survey_template_arr) => {
  // const survey_template_arr = contextValue.survey_template_arr;
  // console.log('contextValue', contextValue);
  // console.log('global_data_ref', global_data_ref);
  // const survey_template_arr = global_data_ref.survey_template_arr;
  let survey_template_arr = [];
  if (typeof _cb_survey_template_arr === 'function') {
    survey_template_arr = _cb_survey_template_arr();
  }
  console.log('_zzsurvey_formDefiinitionCustomer_v1 survey_template_arr', survey_template_arr);
  let _options_templates = [];
  if (Array.isArray(survey_template_arr)) {
    _options_templates = survey_template_arr.map((item) => {
      return {
        "title": item.internal_name,
        "value": item.survey_template_id,
      };
    });
  }
  const def_survey_template_id_select = {
    "type": "select",
    "params": {
      "label": "survey_template_id",
      "name": "survey_template_id",
      "default_option_title": "--select template--",
      "options": [
        ..._options_templates
      ],
      // "w": 240
    }
  };
  return [
    /*
    "name":"Jovan",
    // "surname":"Petrovic",
    "email": "jovan8684@gmail.com",
    "service_type": "Web dizajn",
    "service_date": "2023-02-15",
    "survey_template_id":6,
    "date_to_send_first_email":"2024-02-15",
    "date_to_send_second_email":"2026-01-15"
    */
    {
      "type": "input_text",
      "params": {
        "label": "name",
        "name": "name",
        // "w": 320
      }
    },
    /*
    {
      "type": "input_text",
      "params": {
        "label": "surname",
        "name": "surname",
        // "w": 320
      }
    },
    */
    {
      "type": "input_email",
      "params": {
        "label": "email",
        "name": "email",
        // "w": 320
      }
    },
    //
    {
      "type": "separator",
    },
    {
      "type": "input_text",
      "params": {
        "label": "service_type",
        "name": "service_type",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "service_date",
        "name": "service_date",
        "placeholder": "YYYY-MM-DD",
        // "w": 320
      }
    },
    def_survey_template_id_select,
    {
      "type": "input_text",
      "params": {
        "label": "survey_template_id",
        "name": "survey_template_id",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "date_to_send_first_email",
        "name": "date_to_send_first_email",
        "placeholder": "YYYY-MM-DD",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "date_to_send_second_email",
        "name": "date_to_send_second_email",
        "placeholder": "YYYY-MM-DD",
        // "w": 320
      }
    },
  ];
};


//
export const _zzsurvey_formDefiinitionCustomer_v2 = (clients_of_seller) => {
  // console.log('_zzsurvey_formDefiinitionCustomer_v2');
  /*
  let _options_clients_of_seller = [];
  if (Array.isArray(clients_of_seller)) {
    _options_clients_of_seller = clients_of_seller.map((item) => {
      return {
        "title": item.name,
        "value": item.client_id,
      };
    });
  }
  const def_clients_of_seller = {
    "type": "input_radio_group",
    "params": {
      "valuetype": "number",
      "integer": true,
      "label": "client_id",
      "name": "client_id",
      "default_option_title": "--select client--",
      "options": [
        ..._options_clients_of_seller
      ],
      // "w": 240
    }
  };
  */
  return [
    /*
    // client_id selector
    def_clients_of_seller,
    {
      "type": "input_number",
      "params": {
        "integer": true,
        "label": "client_id",
        "name": "client_id",
        // "w": 320
      }
    },
    */
    //
    /*
    "name":"Jovan",
    // "surname":"Petrovic",
    "email": "jovan8684@gmail.com",
    // PREMESTENA POLJA
    "service_type": "Web dizajn",
    "service_date": "2023-02-15",
    "survey_template_id":6,
    "date_to_send_first_email":"2024-02-15",
    "date_to_send_second_email":"2026-01-15"
    */
    {
      "type": "input_text",
      "params": {
        // "label": "name",
        "label": "Ime i prezime",
        "name": "name",
        // "w": 320
      }
    },
    /*
    {
      "type": "input_text",
      "params": {
        "label": "surname",
        "name": "surname",
        // "w": 320
      }
    },
    */
    {
      "type": "input_email",
      "params": {
        "label": "email",
        "name": "email",
        // "w": 320
      }
    },
    //
    {
      "type": "input_text",
      "params": {
        "label": "phone",
        "name": "phone",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "location",
        "name": "location",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "cdp_sifra",
        "name": "cdp_sifra",
        // "w": 320
      }
    },

    //
    /*
    {
      "type": "separator",
    },
    */
  ];
};


//
export const _zzsurvey_formDefiinitionCustomerRegisterPublic = () => {
  // console.log('_zzsurvey_formDefiinitionCustomerRegisterPublic');
  return [
    /*
    {
      "type": "input_text",
      "params": {
        // "label": "name",
        "label": "Ime i prezime",
        "name": "name",
        // "w": 320
      }
    },
    */
    /*
    {
      "type": "input_email",
      "params": {
        "label": "email",
        "name": "email",
        // "w": 320
      }
    },
    */
    //
    {
      "type": "input_text",
      "params": {
        // "label": "phone",
        "label": "Broj telefona",
        "name": "phone",
        // "w": 320
      }
    },
    /*
    {
      "type": "input_text",
      "params": {
        "label": "location",
        "name": "location",
        // "w": 320
      }
    },
    */
  ];
};


//
export const _zzsurvey_formDefiinitionCdpCustomer = () => {
  // console.log('_zzsurvey_formDefiinitionCdpCustomer');
  return [
    //
    /*
    {
        "client_id": 1,
        "name": "Miki",
        "email": "miki@gmail.com",
        "phone": "+381 000 000 000",
        "location": "Serbia",
        "cdp_sifra": "123"
    }
    */
    /*
    {
      "type": "input_text",
      "params": {
        // "label": "name",
        "label": "Ime i prezime",
        "name": "name",
        // "w": 320
      }
    },
    {
      "type": "input_email",
      "params": {
        "label": "email",
        "name": "email",
        // "w": 320
      }
    },
    //
    {
      "type": "input_text",
      "params": {
        "label": "phone",
        "name": "phone",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "location",
        "name": "location",
        // "w": 320
      }
    },
    */
    {
      "type": "input_text",
      "params": {
        "label": "cdp_sifra",
        "name": "cdp_sifra",
        // "w": 320
      }
    },
    /*
    {
      "type": "input_email",
      "params": {
        "label": "email",
        "name": "email",
        // "w": 320
      }
    },
    */
    //
  ];
};
//
export const _zzsurvey_formDefiinitionConsent = () => {
  // console.log('_zzsurvey_formDefiinitionConsent');
  return [
    //
    /*
    {
        "client_id": 1,
        "name": "Miki",
        "email": "miki@gmail.com",
        "phone": "+381 000 000 000",
        "location": "Serbia",
        "cdp_sifra": "123"
    }
    */
    {
      "type": "input_text",
      "params": {
        // "label": "name",
        "label": "title",
        "name": "title",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        // "readonly": true,
        "label": "internal_name",
        "name": "internal_name",
        "placeholder": "Interni naziv za consent",
        // "w": 320
      }
    },
    {
      "type": "textarea",
      "params": {
        // "label": "name",
        "label": "text",
        "name": "text",
        "placeholder": "Potpisivanjem ove saglasnosti, potvrđujem da sam upoznat/a sa uslovima poslovanja",
        // "w": 320
      }
    },
    {
      "type": "textarea",
      "params": {
        // "label": "name",
        "label": "terms_text",
        "name": "terms_text",
        // "w": 320
      }
    },
    //
  ];
};
//
export const _zzsurvey_formDefiinitionSignConsent = (_cb_consents_arr, consents_arr) => {
  // console.log('_zzsurvey_formDefiinitionSignConsent');
  /*
  let consents_arr = [];
  if (typeof _cb_consents_arr === 'function') {
    consents_arr = _cb_consents_arr();
  }
  */
  console.log('_zzsurvey_formDefiinitionInstance consents_arr', consents_arr);
  let _options_consents = [];
  if (Array.isArray(consents_arr)) {
    _options_consents = consents_arr.map((item) => {
      return {
        "title": item.internal_name,
        "value": item.consent_id,
      };
    });
  }

  const def_consent_id_select = {
    "type": "select",
    "params": {
      "valuetype": "number",
      "integer": true,
      "label": "consent_id",
      "name": "consent_id",
      "default_option_title": "--select consent--",
      "options": [
        ..._options_consents
      ],
      // "w": 240
    }
  };

  return [
    /*
    */
    {
      "type": "input_text",
      "params": {
        "readonly": true,
        "label": "cdp_sifra",
        "name": "cdp_sifra",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "readonly": true,
        "label": "cdp_customer_id",
        "name": "cdp_customer_id",
        // "w": 320
      }
    },
    // -- choose consent
    def_consent_id_select,
    { "type": "separator" },
    /*
    {
      "type": "text",
      "params": {
        "title": "UNDER CONSTRUCTION..."
      }
    },
    */
  ];
};


//
export const _zzsurvey_formDefiinitionInstance = (_cb_survey_customer_arr, _cb_survey_template_arr, multiple = false, seller_selected_multiple_ccustomer_ids) => {
  // console.log('_zzsurvey_formDefiinitionCustomer_v1');
  // const survey_template_arr = contextValue.survey_template_arr;
  // console.log('contextValue', contextValue);
  // console.log('global_data_ref', global_data_ref);
  // const survey_template_arr = global_data_ref.survey_template_arr;
  let survey_customer_arr = [];
  if (typeof _cb_survey_customer_arr === 'function') {
    survey_customer_arr = _cb_survey_customer_arr();
  }
  let survey_template_arr = [];
  if (typeof _cb_survey_template_arr === 'function') {
    survey_template_arr = _cb_survey_template_arr();
  }
  console.log('_zzsurvey_formDefiinitionInstance survey_customer_arr', survey_customer_arr);
  console.log('_zzsurvey_formDefiinitionInstance survey_template_arr', survey_template_arr);
  let _options_templates = [];
  if (Array.isArray(survey_template_arr)) {
    _options_templates = survey_template_arr.map((item) => {
      return {
        "title": item.internal_name,
        "value": item.survey_template_id,
      };
    });
  }

  const def_survey_template_id_select = {
    "type": "select",
    "params": {
      "valuetype": "number",
      "integer": true,
      "label": "survey_template_id",
      "name": "survey_template_id",
      "default_option_title": "--select template--",
      "options": [
        ..._options_templates
      ],
      // "w": 240
    }
  };
  let _def_part_customer = [];
  if (multiple === true) {
    _def_part_customer = [];
  } else {
    let _options_customers = [];
    if (Array.isArray(survey_customer_arr)) {
      _options_customers = survey_customer_arr.map((item) => {
        return {
          "title": item.email,
          "value": item.customer_id,
        };
      });
    }
    const def_customer_id_select = {
      "type": "select",
      "params": {
        "valuetype": "number",
        "integer": true,
        "label": "customer_id",
        "name": "customer_id",
        "default_option_title": "--select customer--",
        "options": [
          ..._options_customers
        ],
        // "w": 240
      }
    };
    _def_part_customer = [
      /*
      {
        "type": "input_text",
        "params": {
          "label": "name",
          "name": "name",
          // "w": 320
        }
      },
      {
        "type": "input_text",
        "params": {
          "label": "surname",
          "name": "surname",
          // "w": 320
        }
      },
      {
        "type": "input_email",
        "params": {
          "label": "email",
          "name": "email",
          // "w": 320
        }
      },
      */
      //
      /*
      {
        "type": "separator",
      },
      */
      // --- choose customer
      def_customer_id_select,
      /*
      {
        "type": "input_number",
        "params": {
          "integer": true,
          "label": "customer_id",
          "name": "customer_id",
          // "w": 320
        }
      },
      */
    ];
  }
  return [
    /*
    "name":"Jovan",
    // "surname":"Petrovic",
    "email": "jovan8684@gmail.com",
    "service_type": "Web dizajn",
    "service_date": "2023-02-15",
    "survey_template_id":6,
    "date_to_send_first_email":"2024-02-15",
    "date_to_send_second_email":"2026-01-15"
    */
    /*
    {
      "customer_id": 8,
      "survey_template_id": 2,
      "service_date": "2020-02-15",
      "date_to_send_first_email": "2025-01-15",
      "date_to_send_second_email": "2025-03-15",
      "date_due": "2025-04-20"
    }
    */
    // -- choose customer
    ..._def_part_customer,
    // -- choose template
    def_survey_template_id_select,
    {
      "type": "input_number",
      "params": {
        "integer": true,
        "label": "survey_template_id",
        "name": "survey_template_id",
        // "w": 320
      }
    },
    /*
    {
      "type": "input_text",
      "params": {
        "label": "service_type",
        "name": "service_type",
        // "w": 320
      }
    },
    */
    {
      "type": "input_text",
      "params": {
        "label": "service_date",
        "name": "service_date",
        "placeholder": "YYYY-MM-DD",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "date_to_send_first_email",
        "name": "date_to_send_first_email",
        "placeholder": "YYYY-MM-DD",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "date_to_send_second_email",
        "name": "date_to_send_second_email",
        "placeholder": "YYYY-MM-DD",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "date_due",
        "name": "date_due",
        "placeholder": "YYYY-MM-DD",
        // "w": 320
      }
    },
  ];
};


//
export const _zzsurvey_formDefiinitionSurveyHeader = (editorQuizHeader) => {
  let _def_review = [];
  if (editorQuizHeader?.is_review === true) {
    _def_review = [
      {
        "type": "textarea",
        "params": {
          "label": "review_text",
          "name": "review_text",
          // "w": 320
        }
      },
      {
        "type": "input_text",
        "params": {
          "label": "review_link",
          "name": "review_link",
          // "w": 320
        }
      },
    ];
  }
  // NOVO 2025-07-12
  let _def_email_fields = [];
  if (editorQuizHeader?._by_email_or_direct === "WITHOUT_EMAIL") { // CASE without email
    // no changes
  } else { // CASE with email fields
    _def_email_fields = [
      {
        "type": "textarea",
        "params": {
          // "readonly": true,
          "label": "first_email_title",
          "name": "first_email_title",
          // "w": 320
        }
      },
      {
        "type": "textarea",
        "params": {
          // "readonly": true,
          "label": "first_email_content",
          "name": "first_email_content",
          // "w": 320
        }
      },
      {
        "type": "textarea",
        "params": {
          // "readonly": true,
          "label": "second_email_title",
          "name": "second_email_title",
          // "w": 320
        }
      },
      {
        "type": "textarea",
        "params": {
          // "readonly": true,
          "label": "second_email_content",
          "name": "second_email_content",
          // "w": 320
        }
      },
    ];
  }
  //
  return [
    {
      "type": "input_text",
      "params": {
        // "readonly": true,
        "label": "internal_name",
        "name": "internal_name",
        "placeholder": "Interni naziv ankete",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        // "readonly": true,
        "label": "title",
        "name": "title",
        // "w": 320
      }
    },
    {
      "type": "textarea",
      "params": {
        // "readonly": true,
        "label": "survey_text",
        "name": "survey_text",
        // "w": 320
      }
    },
    /*
    { // TODO // service_type must be either Prodaja or Servis.
      "type": "input_text",
      "params": {
        "label": "service_type",
        "name": "service_type",
        "placeholder": "My service",
        // "placeholder": "YYYY-MM-DD",
        // "w": 320
      }
    },
    */
    { // TODO // service_type must be either Prodaja or Servis.
      "type": "select",
      "params": {
        "label": "service_type",
        "name": "service_type",
        // "options": ["Prodaja", "Servis"],
        "options": ["Prodaja", "Servis", "Reklamacija", "Limarija"],
      }
    },
    /*
        first_email_title: '',
        first_email_content: '',
        second_email_title: '',
        second_email_content: '',
    */
    {
      "type": "input_radio_group",
      "params": {
        "label": "Anketa se šalje/ne šalje",
        "name": "_by_email_or_direct",
        "options": [
          {
            "title": "Šalje na email",
            "value": "",
          },
          {
            "title": "Popunjava se odmah bez email-a",
            "value": "WITHOUT_EMAIL",
          },
        ],
        "outline": false,
        "extraclass": "novo-radios-column",
      }
    },
    ..._def_email_fields,
    // review
    {
      "type": "input_checkbox",
      "params": {
        "label": 'Enable "Review us" step',
        "name": "is_review",
      }
    },
    ..._def_review,
  ];
};


//
export const _zzsurvey_formDefinitionGoogleReviewsApi = () => {
  return [
    {
      "type": "input_text",
      "params": {
        "label": "google_reviews_api_key",
        "name": "google_reviews_api_key",
        // "w": 320
      }
    },
    {
      "type": "input_text",
      "params": {
        "label": "google_reviews_place_id",
        "name": "google_reviews_place_id",
        // "w": 320
      }
    },
  ];
};


// ---------- make exportable table


const _zzsurvey_utils_make_exportable_tabular_data = (instance_arr, is_anon_disabled) => {
  const tabular = []; // tabular data
  if (Array.isArray(instance_arr)) {
    instance_arr.forEach((item, index) => {
      const status = item.status;
      // _status_sufix = '?status=' + status;
      // if (status === 'pending' || status === 'filled' || status === 'expired') {
      // TODO Export u excel samo popunjene ankete
      if (status === 'filled') {
        let is_anon = false;
        if (item?.is_anonymous === true) {
          is_anon = true;
        }
        const row = {
          status: status,
          // --- customer columns
          // is_anonymous: item?.customer?.is_anonymous,
          is_anonymous: is_anon,
          customer_id: item?.customer?.customer_id,
          email: item?.customer?.email,
          name: item?.customer?.name,
          // surname: item?.customer?.surname,
          phone: item?.customer?.phone,
          location: item?.customer?.location,
          cdp_sifra: item?.customer?.cdp_sifra,
          // --- instance columns
          service_type: item.service_type,
          service_date: item.service_date,
          date_to_send_first_email: item.date_to_send_first_email,
          date_to_send_second_email: item.date_to_send_second_email,
          date_due: item.date_due,
          is_first_email_sent: item.is_first_email_sent,
          is_second_email_sent: item.is_second_email_sent,
          date_filled: item.date_filled,
          // template columns
          survey_template_id: item.survey_template_id,
          internal_name: item.internal_name,
          // title: item.title,
          survey_title: item.title,
        };
        if (is_anon === true && is_anon_disabled !== true) {
          row.customer_id = '';
          row.email = '';
          row.name = '';
          // row.surname = '';
          row.phone = '';
          row.location = '';
          row.cdp_sifra = '';
        }
        // --- questions and answers
        if (Array.isArray(item.questions)) {
          item.questions.forEach((q, index) => {
            const q_prefix = 'q' + (index + 1) + '_';
            row[q_prefix + 'question_id'] = q.question_id;
            row[q_prefix + 'title'] = q.title;
            row[q_prefix + 'question_type'] = q.question_type;
            row[q_prefix + 'answer'] = q.answer;
            row[q_prefix + 'extra_answer'] = q.extra_answer;
          });
        }
        //
        tabular.push(row);
      }
    });
  }
  return tabular;
};


//
export const _zzsurvey_utils_export_excel_table_v0_1 = (instance_arr, is_anon_disabled) => {
  const tabular = _zzsurvey_utils_make_exportable_tabular_data(instance_arr, is_anon_disabled);
  const _table_aoa = tabular;
  //
  //
  const excelExportPack_make = (_table_aoa) => {
    //
    //
    const current_time_utc = new Date().toISOString();
    // const datum_ispisa = current_time_utc.slice(0, 10);
    //
    const _make_exportedFilename = () => {
      /*
      Nosioc trosak-Ident-Naziv sistema-datumivreme
      23AT0397-AHU774293-Naziv sistema_datum i vreme_SASTAVNICA.xlsx
      */
      //
      const exportedFilename = 'ratemyservice_EXPORT_' + current_time_utc.slice(0, 16).replaceAll(':', '-') + '.xlsx';
      return exportedFilename;
    };
    const exported_excel_file_fileame = _make_exportedFilename();
    //
    const keyval_header_data = [];
    //
    //
    let _tableCellsDefinition = [];
    console.log('tabular', tabular);
    let first_row = { status: null };
    if (_table_aoa[0]) {
      first_row = _table_aoa[0];
    }
    const row_keys = Object.keys(first_row);
    const excel_keys = _excel_utils_excel_column_sorted_keys_make(row_keys.length, true);
    row_keys.forEach((key, index) => {
      // const val = state[key];
      // const _column_key = key.toUpperCase();
      const _excel_column_key = excel_keys[index];
      if (true) { // validate quick
        const _def = {
          // colindex: 0,
          colindex: index,
          title: key, // header cell value
          // key: _column_key,
          key: key, // body cell value is row[key]
          // wch: 6.5,
          // wch: 15, // prosecna sirina
          // wch: 30,
          wch: 25,
          // wpx: 57,
          /*
          cb: (row_obj, row_index) => {
            // const body_row_no = _R + 1; // brojac ispisanih "body" redova (ispod header reda) pocinje od 1.
            const body_row_no = row_index + 1; // brojac ispisanih "body" redova (ispod header reda) pocinje od 1.
            // return val;
            return body_row_no;
          }, // extractor
          */
        };
        _tableCellsDefinition.push(_def);
      } else {
        // do nothing
      }
    }); // end of forEach
    //
    // const TABLE_HEADER_ROW_INDEX = 9;
    // const HOW_MANY_EMPTY_ROWS_AFTER_KEYVAL_HEADER = 1;
    const generalDefinition = {
      HOW_MANY_EMPTY_ROWS_AFTER_KEYVAL_HEADER: 0,
      TABLE_HEADER_ROW_HEIGHT: 27.75,
    };
    //
    console.log('_tableCellsDefinition', _tableCellsDefinition);
    console.log('_table_aoa', _table_aoa);
    const excelExportPack = {
      // fileTitle: fileTitle, // TODO
      //
      generalDefinition,
      keyval_header_data,
      tableCellsDefinition: _tableCellsDefinition,
      table_data: _table_aoa, // array of objects
      exportedFilename: exported_excel_file_fileame,
    };
    return excelExportPack;
  };
  //
  const excelExportPack = excelExportPack_make(_table_aoa);
  //
  _excel_utils_export_table_with_keyval_header(excelExportPack);
};


//
const _zzsurvey_utils_dictionary = {
  customer_id: "ID",
  // is_anonymous: "Sakriti",
  name: "Ime i prezime",
  // surname: "Prezime",
  // email:
  phone: "Telefon",
  location: "Lokacija",
  cdp_sifra: "CDP šifra",
  is_low_ratings: "Loše ocene",
  last_sales_date: "Poslednja prodaja",
  last_service_date: "Poslednji servis",
  sales_count: "Broj prodaja",
  service_count: "Broj servisa",
  pending_surveys_count: "Otvorene ankete",
  date_created: "Kreiran",
  date_updated: "Ažuriran",
};
//
export const _zzsurvey_utils_translate = (column_key) => {
  if (_zzsurvey_utils_dictionary[column_key] && typeof _zzsurvey_utils_dictionary[column_key] === 'string') { // return translation fro mdictionary
    return _zzsurvey_utils_dictionary[column_key]; // ret
  }
  return column_key; // return unchanged
};


//
export const _zzsurvey_utils_fix_val_for_display_in_table = (column_key, val) => {
  if (typeof column_key === 'string' && typeof val === 'string') {
    if (column_key.includes("date") && val.length > 18) { // detected date field
      const fixed_date = val.substring(0, 19).replace('T', ' ');
      return fixed_date;
    }
  }
  return val;
};

